import { atom, useAtom } from "jotai";

const releaseNotesModalIsOpenAtom = atom<boolean>(false);
const releaseNotesLoadingAtom = atom<boolean>(true);

export const useReleaseNotesState = () => {
  const [releaseNotesModalIsOpen, setReleaseNotesModalIsOpen] = useAtom(
    releaseNotesModalIsOpenAtom,
  );
  const [releaseNotesLoading, setReleaseNotesLoading] = useAtom(releaseNotesLoadingAtom);

  return {
    releaseNotesModalIsOpen,
    setReleaseNotesModalIsOpen,
    releaseNotesLoading,
    setReleaseNotesLoading,
  };
};
